<template>
  <div id="main-container">
    <LoadingSpinner v-if="loading" message="Loading carousel" />

    <div v-else>
      <ErrorMsg v-if="errorMessage" :message="errorMessage" />
      <Slider v-else :data="data" />
    </div>
  </div>
</template>

<script>
import Slider from './components/Slider.vue'
import LoadingSpinner from './components/LoadingSpinner.vue'
import ErrorMsg from './components/ErrorMsg.vue'
import fetchDirectory from './api/fetchDirectory.js'

export default {
  name: 'App',

  components: {
    Slider,
    LoadingSpinner,
    ErrorMsg,
  },

  data() {
    return {
      data: [],
      errorMessage: '',
      loading: true,
    }
  },

  async created() {
    this.loading = true
    try {
      this.data = await fetchDirectory()

      if (this.data.length === 0) {
        this.errorMessage = 'Carousel empty'
      }
    } catch (err) {
      console.warn(err)

      this.errorMessage = 'Error fetching carousel'
    }
    this.loading = false
  },
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 100%;
}

#main-container {
  margin-top: 20px;
}

$rootPath: '../../../..';

@font-face {
  font-family: 'AvenirBlack';
  src: url(#{$rootPath}/css/fonts/AvenirBlack.ttf);
}

@font-face {
  font-family: 'AvenirRoman';
  src: url(#{$rootPath}/css/fonts/AvenirRoman.ttf);
}
</style>
